import axios from 'axios';
import { NqdbEntities } from '../type/types';
import { AuthContextProps } from 'react-oidc-context';

class CalcApi {

   putNQDB(entities: NqdbEntities[], auth: AuthContextProps) {
      const url = this.getBaseUrl() + `/v1/statement/NqdbStatement`;
      const accessToken = auth.user?.access_token;
      const headers = {
         'Authorization': 'Bearer ' + accessToken,
         'Consumer-Name': 'nqdb-ui'
      };

      return axios.post(url, entities, { headers });
   }

   getBaseUrl() {
      if (process.env.REACT_APP_SERVER_ENV === 'production') {
         return "https://liability-balance.usis-nq-liability.prod.principalaws.com";
      } else if (process.env.REACT_APP_SERVER_ENV === 'staging') {
         return "https://liability-balance.usis-nq-liability.staging.principalaws.com";
      } else {
         return "https://liability-balance.usis-nq-liability.dev.principalaws.com";
      }
   }
}

export default CalcApi;